import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

import {Observable, of} from 'rxjs';

import {catchError, tap} from 'rxjs/operators';
import {AppConfigService} from './appconfig.service';
import {ProfileService} from '../../../../../shared/src/lib/services/profile.service';
import { ToolsService } from 'projects/shared/src/lib/services/tools.service';
import { environment } from 'projects/frontend/src/environments/environment';

@Injectable({providedIn: 'root'})
export class HttpService {
  protected host = '';
  protected headers: any;
  protected errorCode = '';

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private appConfigService: AppConfigService,
    public toolsService: ToolsService,
    private profileService: ProfileService,
  ) {
    this.host = this.appConfigService?.getConfig()?.settings?.apiServer.configurationHost ?? '';
    // console.log('host', this.host);
  }

  /** GET generic from the server */
  getCallHttp<T>(call: string): Observable<T> {
    this.profileService.resourceNotFound = false;
    this.profileService.setHeaderToken();
    return this.http.get<T>(this.host + '' + call, this.profileService.httpOptionsBearer)
      .pipe(
        tap(res => {
          this.catchResponseError(res);
          return res;
        }),
        catchError(this.handleError<any>('getCallHttp'))
      );
  }

  /** POST generic from the server */
  postCallHttp(call: string, payload: any): Observable<any[]> {
    this.profileService.setHeaderToken();
    return this.http.post<any[]>(this.host + '' + call, JSON.stringify(payload), this.profileService.httpOptionsBearer)
      .pipe(
        tap(
          res => {
            this.catchResponseError(res);
            return res;
          },
        ),
        catchError(this.handleError<any>('postCallHttp'))
      );
  }

  /** PUT generic from the server */
  putCallHttp(call: string, payload: any): Observable<any[]> {
    this.profileService.setHeaderToken();
    return this.http.put<any[]>(this.host + '' + call/* + '/' + id*/, JSON.stringify(payload), this.profileService.httpOptionsBearer)
      .pipe(
        tap(res => {
          this.catchResponseError(res);
          return res;
        }),
        catchError(this.handleError<any>('putCallHttp'))
      );
  }

  /** DELETE generic from the server */
  deleteCallHttp(call: string): Observable<any> {
    this.profileService.setHeaderToken();
    return this.http.delete<any>(this.host + '' + call, this.profileService.httpOptionsBearer).pipe(
      tap(_ => this.logInfo(`deleted call=${call}`)),
      catchError(this.handleError<any>('deleteCallHttp'))
    );
  }

  /** UPLOAD generic from the server */
  uploadCallHttp(call: string, formData: any): Observable<any[]> {
    this.profileService.setHeaderToken();
    return this.http.post<any[]>(this.host + '' + call, formData, this.profileService.httpOptionsBearer)
      .pipe(
        tap(
          res => {
            this.catchResponseError(res);
            return res;
          },
        ),
        catchError(this.handleError<any>('uploadCallHttp'))
      );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 404 || error.status === 409) {
        if (error.status === 403) {
          this.router.navigate(['/']);
        } else if (error.status === 404) {
          this.showErrorMessage('Resource not found', 'Error', 'warning');
          this.profileService.resourceNotFound = true;
        } else {
          if (error.error && this.errorCode != error.error.errorCode) {
            this.showErrorMessage(error.error.errorMessage, error.error.errorCode);
            this.errorCode = error.error.errorCode;
          }
        }
      } else if (error.status === 500) {
        if (error.error && error.error.error) {
          this.logError(error.error.error);
        } else {
          this.logError(`${error.message}`);
        }
      } else {
        console.error(error)
      }
      if (error.error &&
        error.error.validationMessages &&
        error.error.validationMessages.length > 0) {
        error.error.validationMessages.forEach((message: any) => {
          this.showErrorMessage(message.validationMessage, 'Validazione', 'warning');
        });
      }
      return of(result as T);
    };
  }

  private logInfo(message: string) {
    // this.toastr.info(message, 'Info');
  }

  private logError(message: string) {
    this.toastr.error(message, 'Generic Error');
  }

  showErrorMessage(errorMessage: string, title: string, type?: string) {
    errorMessage = errorMessage && errorMessage != null && errorMessage != '' ? errorMessage : 'Contact the administrator!';
    title = title && title != null && title != '' ? title : 'Error';

    const substringsToCheck = environment.substringsToCheck ?? [];
    console.groupCollapsed('### error');
    console.error("### errorMessage",errorMessage);
    console.log("### substringsToCheck",substringsToCheck);
    console.groupEnd();
    if (!this.toolsService.containsSubstring(errorMessage.toLowerCase(), substringsToCheck)) {
      if (type && type == 'warning') {
        this.toastr.warning(errorMessage, title);
      } else {
        this.toastr.error(errorMessage, title);
      }
    }
  }

  catchResponseError(res: any) {
    if (res) {
      if (res.ErrorNumber === -99) {
        this.errorAlert('Session not valid!');
        return;
      } else if (res.ErrorNumber === -1) {
        this.errorAlert('Session expired!');
        return;
      } else if (res.ErrorNumber === 4) {
        this.errorAlert('Access Denied!');
        return;
      }

    }
  }

  errorAlert(message: string) {
    // Swal.fire({
    //   title: message,
    //   text: 'You will be redirect in login page.',
    //   type: 'error',
    //   confirmButtonText: 'Ok',
    //   timer: 5000
    // });
  }
}
